import {
  classifyIncident,
  type IncidentKind,
  type IncidentThresholds,
  type MediaHealth,
} from './incidents';

export type IncidentChange =
  | { readonly type: 'incident'; readonly kind: IncidentKind; readonly t: number }
  | { readonly type: 'incidentCleared' };

export interface IncidentWatcher {
  /** Nouvel état de santé ; renvoie un événement seulement sur une TRANSITION. */
  update(health: MediaHealth, now: number): IncidentChange | null;
  reset(): void;
}

export function createIncidentWatcher(
  thresholds: Partial<IncidentThresholds> = {},
): IncidentWatcher {
  let current: IncidentKind | null = null;
  return {
    update(health, now) {
      const kind = classifyIncident(health, thresholds);
      if (kind === current) return null;
      current = kind;
      return kind ? { type: 'incident', kind, t: now } : { type: 'incidentCleared' };
    },
    reset() {
      current = null;
    },
  };
}
